import { Download } from "lucide-react";
import { useTranslate } from "ra-core";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemGroup,
  ItemTitle,
} from "@/components/ui/item";

import { useInstallAction } from "./useInstallAction";

/** "Install app" row of the mobile settings page, shown only when installable. */
export const InstallAppSection = () => {
  const translate = useTranslate();
  const { isAvailable, install } = useInstallAction();
  if (!isAvailable) return null;
  return (
    <ItemGroup className="rounded-lg border overflow-hidden">
      <Item asChild size="sm" className="cursor-pointer">
        <button type="button" onClick={install}>
          <ItemContent>
            <ItemTitle className="font-normal">
              {translate("crm.pwa.install_app")}
            </ItemTitle>
          </ItemContent>
          <ItemActions>
            <Download className="size-4 text-muted-foreground" />
          </ItemActions>
        </button>
      </Item>
    </ItemGroup>
  );
};
